import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() => ({
  statusChip: {
    height: 24,
    maxWidth: 148,
    borderRadius: 100,
    padding: "4px 12px",
    pointerEvents: "none",
    "& > span": {
      fontFamily: "Manrope",
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "16px",
      letterSpacing: 0.5,
    },
  },

  arrowIcon: {
    fontSize: "16px",
    pointerEvents: "none",
    color: colors.gray500,
    margin: 0,
    padding: 0,
  },
}));

export const OrderOption = styled("div")(() => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
}));

export const OrderOptionHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
  width: "100%",
}));

export const OrderReference = styled("span")(() => ({
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  pointerEvents: "none",
}));

export const CustomerName = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  pointerEvents: "none",
}));

export const TaskAddressContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "4px",
  flexWrap: "nowrap",
  whiteSpace: "nowrap",
  width: "max-content",
  maxWidth: "100%",
}));

export const TaskAddress = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  pointerEvents: "none",

  width: "max-content",
  whitesSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const Arrow = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  pointerEvents: "none",
}));

export default useStyles;
